<div class="suggest-item case-suggest-item" (click)="openCase()">
  <b>{{patientName}}</b><span [class.no-separator]="!patientName">Case #{{caseId}}</span>
</div>
